import type { ContentFragment } from '@oneaudi/falcon-tools';
import type { FeatureAppConfig } from '../FeatureHubAppDefinition';

export type FalconConfig = {
  __type?: 'aem-headless';
  config?: Partial<ContentFragment> & {
    fields: FeatureAppConfig;
  };
};

export type FootnoteFields = {
  Key: string;
  Text: string;
  position?: number;
};
export type FefaProps = {
  url?: string;
  urls?: string[];
  footnotes: FootnoteFields[];
};

export type Footnote = {
  fields: FootnoteFields;
};
export type CollectionContentHeadless = {
  __type: string;
  fields: {
    Footnotes: {
      fields: {
        Footnotes: Footnote[];
      };
    };
  };
};
export type ContentHeadless = {
  __type: string;
  fields: {
    FootnotesURL?: string;
    FootnoteURLs?: string[];
    Footnotes: {
      fields: {
        Footnotes: Footnote[];
      };
    };
  };
};

export function normalizeConfig(
  config?: FeatureAppConfig | FalconConfig,
): FeatureAppConfig | undefined {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (config?.__type === 'aem-headless') {
    const falconConfig = config as FalconConfig;
    return {
      disclaimerManagerScope:
        falconConfig.config?.fields.disclaimerManagerScope !== undefined
          ? falconConfig.config.fields.disclaimerManagerScope
          : 'DEFAULT',
      ...falconConfig.config?.fields,
    };
  }
  return config as FeatureAppConfig;
}

export function normalizeContentHeadlessCollection(
  content: CollectionContentHeadless,
): FootnoteFields[] {
  const footnotes: FootnoteFields[] = [];
  const rawFootnotes = content?.fields?.Footnotes;

  if (Array.isArray(rawFootnotes)) {
    rawFootnotes.forEach((ftn) => {
      // Case 2: ftn has nested fields.Footnotes array
      if (Array.isArray(ftn?.fields?.Footnotes)) {
        ftn.fields.Footnotes.forEach((nestedFtn: { fields: FootnoteFields }) => {
          footnotes.push(nestedFtn.fields);
        });
      } else {
        // Case 1: ftn itself is a footnote
        footnotes.push(ftn.fields);
      }
    });
  }

  return footnotes;
}

export function normalizeContentHeadless(content: ContentHeadless): FefaProps {
  const footnotes: FootnoteFields[] = [];
  content?.fields?.Footnotes?.fields?.Footnotes?.forEach((ftn) => {
    footnotes.push(ftn.fields);
  });

  let urls: string[] | undefined = [];
  if (content?.fields?.FootnotesURL && content?.fields?.FootnotesURL !== '') {
    urls.push(content?.fields?.FootnotesURL);
  } else {
    urls = content?.fields?.FootnoteURLs;
  }

  return {
    urls,
    footnotes,
  };
}
